import { HttpClient } from "@angular/common/http";
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { SettingsService } from "app/@core/backend/common/services/settings.service";
import { TfAdminLoginService } from "app/@core/backend/common/services/tfAdminLogin.service";
import { AppSettings, AppSettingsData } from "app/@core/interfaces/common/appSettings";
import { Settings } from "app/@core/interfaces/common/settings";
import { User } from "app/@core/interfaces/common/users";
import { JSONStringify } from "app/SupportOps";

export interface AppSettingsConfigurations {
  appStorePassword: string | null;
  keyId: string | null;
  issuerId: string | null;
  username: string | null;
  teamId: string | null;
  teamName: string | null;
  bundleId: string | null;
  branchName: string | null;
  token: string | null;
  version?: string;
}

@Component({
  selector: "app-settings",
  templateUrl: "./app-settings.component.html",
  styleUrls: ["./app-settings.component.scss"],
})
export class AppSettingsComponent implements OnInit {
  public appSettings: AppSettings;
  @Input() public disabled: boolean = false;
  @Input() public user: User;
  @Input() public userSettings: Settings;
  @Output() public userSettingsChange = new EventEmitter<{
    user: User,
    settings: Settings,
  }>();
  public configurations: AppSettingsConfigurations = {
    appStorePassword: null,
    keyId: null,
    issuerId: null,
    username: null,
    teamId: null,
    teamName: null,
    bundleId: null,
    branchName: null,
    token: null,
  };
  constructor(
    private appSettingService: AppSettingsData,
    private settingsService: SettingsService,
    private httpClient: HttpClient,
  ) {}
  ngOnInit(): void {

        this.appSettingService.get(this.user.id).subscribe(res => {
          console.log(res);
          if(res) {
            this.appSettings = res;
            if(res.configuration)
            this.configurations = JSON.parse(res.configuration);
          } else {
            this.appSettings = {
              userId: this.user.id,
              apkUrl: null,
              ipaUrl: null,
              abbUrl: null,
              googleAndroidServiceJson: null,
              googleIosServiceJson: null,
              id: null,
              configuration: JSONStringify(this.configurations),
            }
          }
        });
  }

  public runBuild() {
    this.appSettingService.runBuild(this.user.id).subscribe(res => {
      console.log(res);
    });
  }

  tokenFileUpload(event: any): void{
    const file = event.target.files[0];
    if (!file) {
        return;
    }

    const reader = new FileReader();
    reader.onload = (fileLoadEvent) => {
        const text = fileLoadEvent.target.result;
            this.configurations.token = text as string;
    }
    reader.readAsText(file);
  }

  changeIsCustomAppInProduction(event) {
    this.user.isCustomAppInProduction = event;
  }

  changeCustomAppEnabled(event) {
    this.user.customAppEnabled = event;
  }

  saveChanges() {
    this.appSettings.configuration = JSONStringify(this.configurations);
    this.appSettingService.update(this.appSettings).subscribe(res => {
      console.log(res);
    });
    this.userSettingsChange.emit({
      user: this.user,
      settings: this.userSettings,
    });
    this.settingsService.updateUserSettings({...this.userSettings,id: this.user.id, appLogo: null, logo: null, color: JSON.stringify(this.userSettings.color), appColor: JSON.stringify(this.userSettings.appColor)}).subscribe(res => {
      console.log(res);
    });
  }


  syncTfToGhl() {
    this.httpClient.get(`https://trainerfriend-function-prod.azurewebsites.net/api/SyncTrainerfriendToGhl?email=${this.user.email}`).subscribe(res => {
      console.log("Synced");
    });
  }
}
